import { getHeaders } from '../../core/actions/xhrRequest';
import { createAction } from 'redux-api-middleware';

export const APPLY_STATUS_PENDING = 'APPLY_STATUS_PENDING';
export const APPLY_STATUS_SUCCESS = 'APPLY_STATUS_SUCCESS';
export const APPLY_STATUS_FAILURE = 'APPLY_STATUS_FAILURE';

export const CHECK_APPLY_VALUE_INIT = 'CHECK_APPLY_VALUE_INIT';
export const CHECK_APPLY_VALUE_SUCCESS = 'CHECK_APPLY_VALUE_SUCCESS';
export const CHECK_APPLY_VALUE_FAILURE = 'CHECK_APPLY_VALUE_FAILURE';

export const CLEAR_APPLY_FIELD = 'CLEAR_APPLY_FIELD';

export const checkCouponCode = (name, code, errorMessage) => createAction({
    types: [
        {
            type: CHECK_APPLY_VALUE_INIT,
            payload: {
                name: name,
                value: code,
                error: errorMessage,
            },
        },
        {
            type: CHECK_APPLY_VALUE_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return {
                        name: name,
                        value: code,
                        status: json.isValid ? APPLY_STATUS_SUCCESS : APPLY_STATUS_FAILURE,
                        data: json,
                        error: errorMessage,
                    }
                });
            }
        },
        {
            type: CHECK_APPLY_VALUE_FAILURE,
            payload: {
                name: name,
                value: code,
                error: errorMessage,
            },
        },
    ],
    endpoint: `/api/coupon/check`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify({code: code}),
    credentials: 'include'
})

export const checkWriterId = (name, code, errorMessage) => createAction({
    types: [
        {
            type: CHECK_APPLY_VALUE_INIT,
            payload: {
                name: name,
                value: code,
                error: errorMessage,
            },
        },
        {
            type: CHECK_APPLY_VALUE_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return {
                        name: name,
                        value: code,
                        status: json.writerMultiplier ? APPLY_STATUS_SUCCESS : APPLY_STATUS_FAILURE,
                        data: json.writerMultiplier ? {ratio: json.writerMultiplier} : {},
                        error: json.error || errorMessage,
                    }
                }).catch(() => {
                    return {
                        name: name,
                        value: code,
                        status: APPLY_STATUS_FAILURE,
                        error: errorMessage,
                    }
                });
            }
        },
        {
            type: CHECK_APPLY_VALUE_FAILURE,
            payload: {
                name: name,
                value: code,
                error: errorMessage,
            },
        },
    ],
    endpoint: `/api/writer/check/${code}`,
    headers: getHeaders(),
    method: 'GET',
    credentials: 'include'
})

export const clearApplyField = name => ({
    type: CLEAR_APPLY_FIELD,
    payload: {name: name},
})
